import React from 'react';
import { Document } from '@frontend/components/common/Document';
import { Chart, ArcElement, Legend, Tooltip, Title } from 'chart.js';
Chart.register(ArcElement, Legend, Tooltip, Title);

export const App: React.FC = () => <Document />;
